module.exports = __webpack_public_path__ + "static/sakurayoga-23ab1f6cde0b63cddf241b09bb1110b8.png";